import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './workplace/auth_plugins'
import Rails from '@rails/ujs'
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
import Turbolinks from 'turbolinks'
import './workplace/auth_application'
import './workplace/form/validation'

window.bootstrap = bootstrap
window.Rails = Rails
window.logFirebaseEvent = window.logFirebaseEvent || function() {}

Rails.start()
Turbolinks.start()

// Preserve the analytics behavior of the full Workplace entry point while
// keeping both SDKs outside the critical synchronous bundle.
if (gon.is_analytics_allowed) {
    import('./workplace/firebase/fireinit')
}

if (gon.uxcam_api_key) {
    import('./shared/uxcam-init')
}
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './workplace/auth_plugins'
import Rails from '@rails/ujs'
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
import Turbolinks from 'turbolinks'
import './workplace/auth_application'
import './workplace/form/validation'

window.bootstrap = bootstrap
window.Rails = Rails
window.logFirebaseEvent = window.logFirebaseEvent || function() {}

Rails.start()
Turbolinks.start()

// Preserve the analytics behavior of the full Workplace entry point while
// keeping both SDKs outside the critical synchronous bundle.
if (gon.is_analytics_allowed) {
    import('./workplace/firebase/fireinit')
}

if (gon.uxcam_api_key) {
    import('./shared/uxcam-init')
}
